import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { selectIsOrganizationDataAccessible } from '@/entities/session';
import { ROUTES } from '@/shared/constants';
import { useAppSelector } from '@/shared/model';

interface Props {
  children: ReactNode;
}

export function DataStatusGuard({ children }: Props) {
  const isOrganizationDataAccessible = useAppSelector(
    selectIsOrganizationDataAccessible,
  );

  if (!isOrganizationDataAccessible) {
    return <Navigate to={ROUTES.home} />;
  }

  return children;
}
